import Vue from "vue";
// import locale from "element-ui/lib/locale";
import VueI18n from "vue-i18n";

Vue.use(VueI18n); // 通过插件的形式挂载

const i18n = new VueI18n({
  // locale: "en-US", // 语言标识
  locale: "zh-CN", // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    "zh-CN": require("./assets/language/zh"), // 中文语言包
    "en-US": require("./assets/language/en") // 英文语言包
  }
});

export default i18n;
